import { NomObjectPermissionRole } from 'src/app/core/constants';
import { Principal } from 'src/app/core/models/object.models';

const ROLE_RANK: Record<number, number> = {
  [NomObjectPermissionRole.OWNER]: 0,
  [NomObjectPermissionRole.ADMIN]: 1,
  [NomObjectPermissionRole.EDITOR]: 2,
  [NomObjectPermissionRole.VIEWER]: 3,
  [NomObjectPermissionRole.CUSTOM]: 4,
};

/**
 * Display order for the permissions matrix: by role, then business admins first, then
 * by name. Pure display normalization, so it runs in the queryFn.
 */
export function sortPrincipalsByRole(principals: Principal[]): Principal[] {
  return [...principals].sort((a, b) => {
    const ar = ROLE_RANK[a.permission_role_id] ?? 99;
    const br = ROLE_RANK[b.permission_role_id] ?? 99;
    if (ar !== br) return ar - br;

    if (a.is_business_admin !== b.is_business_admin) {
      return a.is_business_admin ? -1 : 1;
    }

    return (a.name ?? '').localeCompare(b.name ?? '', undefined, {
      sensitivity: 'base',
    });
  });
}
